export default __webpack_public_path__ + "static/media/img_9.11faa2d5.JPG";